// extracted by mini-css-extract-plugin
export default {"form":"WorkScreen_form__lpsHZ"};